import { useCallback, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { TDispatch } from '../../../../../../../../common/types/dispatch';
import { preparePackages } from '../utils';
import { selectPackage } from '../../../../../../../actions/publishTerms';
import { loadPublishTerms } from '../../../../../../../thunks/publishTerms/loadPublishTerms';
import { IUsePackages } from './types';
import { selectActivePackageId, selectPackages } from '../../../../../../../reducers/v2/publicationPackages/selectors';
import { usePackagesAnalytics } from './usePackagesAnalytics';

export const usePackages = (): IUsePackages => {
  const dispatch = useDispatch<TDispatch>();

  const { trackPackageSelect } = usePackagesAnalytics();

  const packages = useSelector(selectPackages);
  const activePackageId = useSelector(selectActivePackageId);

  const preparedPackages = useMemo(() => preparePackages(packages), [packages]);

  const handleChangePackage = useCallback(
    (newPackageId: string) => {
      const packageServiceId = packages.find(({ id }) => id === newPackageId)!.serviceId;

      trackPackageSelect(packageServiceId);

      dispatch(selectPackage(newPackageId));

      dispatch(loadPublishTerms({ isServicesReload: true }));
    },
    [packages, trackPackageSelect, dispatch],
  );

  return {
    selectedPackageId: activePackageId,
    packages: preparedPackages,
    onChange: handleChangePackage,
  };
};
